import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMinWidth,
} from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  display: flex;
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  height: 150px;
  position: relative;
  box-shadow: rgb(220, 220, 220) 0px 0px 15px;
  z-index: 1;
  overflow: hidden;

  .__react_component_tooltip {
    text-align: center;
    font-weight: 400;
    max-width: 300px;
  }

  ${mediaMaxWidth.smallDesktop} {
    margin: 10px auto;
    width: 650px;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
  }

  ${mediaMaxWidth.phone} {
    flex-direction: column;
    align-items: center;
    height: unset;
    padding: 20px 10px;
    margin: -55px auto 10px auto;
  }
`;

export const Avatar = styled.div`
  display: flex;
  width: 130px;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
`;

export const AvatarPlaceholder = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: #e4e5e7;
  border-radius: 4px;
  width: 130px;
  height: 130px;

  svg {
    font-size: 2em;
    color: #fff;
  }
`;

export const YourAgentBadge = styled.div`
  position: absolute;
  height: 20px;
  background-color: #79D9D9;
  bottom: 0;
  left: 0;
  right: 0;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  text-transform: capitalize;
  font-size: 0.7em;
`;

export const AvatarImage = styled.img`
  width: 130px;
  height: 130px;
  object-fit: cover;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 3px 0 5px 25px;
  font-size: 0.95em;

  ${mediaMaxWidth.phone} {
    padding: 0;
    margin: 20px 0 60px 0;
    height: 90px;
    flex: unset;
  }
`;

interface ILineProps {
  bold?: boolean;
}

export const Line = styled.div`
  font-weight: ${(props: ILineProps) => (props.bold ? "700" : "400")};
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMaxWidth.phone} {
    text-align: center;
  }
`;

export const LineLink = styled.a`
  text-decoration: underline !important;
  color: #333 !important;
  cursor: pointer;

  svg {
    margin-right: 10px;
    font-size: 0.9em;
  }

  &:hover {
    color: #79D9D9 !important;
  }
`;

export const NameText = styled.div`
  display: flex;
  align-items: center;

  ${mediaMaxWidth.phone} {
    justify-content: center;
  }
`;

export const VerifiedBadgeWrapper = styled.div`
  margin-left: 5px;
`;

export const VerifiedBadge = styled.div`
  background-color: #79D9D9;
  color: #fff;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  font-size: 0.75em;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const City = styled.div`
  width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Experience = styled.div`
  width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

interface IContactProps {
  new?: boolean;
}

export const Contact = styled.div`
  text-decoration: underline;
  cursor: pointer;
  position: absolute;
  left: 165px;
  bottom: 12px;
  font-size: 0.85em;

  &:hover {
    color: #79D9D9;
  }

  ${mediaMaxWidth.phone} {
    left: 0;
    right: 0;
    text-align: center;
    bottom: ${(props: IContactProps) => (props.new ? "75px" : "140px")};
    bottom: 210px;
    justify-content: center;
  }
`;

export const Score = styled.div`
  display: flex;
  width: 155px;
  flex-direction: column;

  ${mediaMinWidth.mediumDesktop} {
    width: 170px;
  }

  ${mediaMaxWidth.phone} {
    align-items: center;
    width: unset;
  }
`;

export const UserScore = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-start;
  flex-direction: column;
`;

export const StarRating = styled.div`
  unicode-bidi: bidi-override;
  color: #ccc;
  font-size: 22px;
  position: relative;
  margin: 4px 0 0 0;
  padding: 0;
  width: 110px;
`;

export const ReviewsCount = styled.div`
  font-size: 0.85em;
  width: 110px;
  display: flex;
  justify-content: center;

  a {
    text-decoration: underline;
    color: #333 !important;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
      color: #79D9D9 !important;
    }
  }
`;

export const Stars = styled.span``;

export const FillRating = styled.div`
  color: #79D9D9;
  padding: 0;
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  overflow: hidden;

  span {
    display: inline-block;
  }
`;

export const EmptyRating = styled.div`
  padding: 0;
  display: block;
  z-index: 0;
`;

export const ScoreTitle = styled.div`
  font-size: 0.9em;
  height: 25px;
  display: flex;
  align-items: center;
`;

export const ScoreCount = styled.div`
  font-weight: 700;
  margin: 0 10px;
  font-size: 1.2em;
  height: 25px;
  display: flex;
  align-items: center;
`;

export const NewBadge = styled.div`
  position: absolute;
  height: 30px;
  background-color: #79D9D9;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.8em;
  width: 105px;
  transform: rotate(-35deg);
  right: -32px;
  bottom: 3px;
  box-shadow: 0 0 10px #d2d2d2;
`;

export const MobileMemberSince = styled.div`
  font-size: 0.95em;
  font-weight: 400;
  margin-top: 20px;
  width: 135px;
  text-align: center;

  ${mediaMinWidth.phone} {
    display: none;
  }

  ${mediaMaxWidth.phone} {
    font-size: 0.85em;
  }
`;

export const Tooltip = styled.div`
  margin: 0 5px;
  cursor: pointer;
  display: flex;
  align-items: center;

  svg {
    font-size: 0.85em;
    color: rgb(187, 187, 187);
    transition: all 0.1s ease-in-out 0s;
  }
`;
